module.exports = __webpack_public_path__ + "img/academy-next.8d0d8051.svg";